import template from './print_packing_slip.html';
import controller from './print_packing_slip.controller';
import './print_packing_slip.scss';

let printPackingSlipComponent = {
  bindings: {},
  template,
  controller
};

export default printPackingSlipComponent;



// WEBPACK FOOTER //
// ./client/app/components/order_packing/print_packing_slip/print_packing_slip.component.js